import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/userLoginSagas";
import FilterByType from "./FilterByType";

const Filters = () => {
  const dispatch = useDispatch();
  const {
    filters,
    selectedFilters,
    selectedTypeOption,
    currentUser: { sourceType }
  } = useSelector((state) => state.userLoginsReducer);
  const defaultParams = {
    filterType: "Custom Range",
    numberDisplayed: 0,
    selectAll: true,
    includeSelectAll: true,
    enableOnly: true,
    defaultSelected: false,
    haveOnSelectChange: false,
    selectedFilters,
    updateLocations: (data) => dispatch(actionCreators.updateFilters(data))
  };
  const arraySort = (array, key) => {
    return array.sort((a, b) => {
      return a[key].localeCompare(b[key], "en", { sensitivity: "base" });
    });
  };
  const sort = (array) => {
    let optionsForNames = arraySort(array, "name");
    let optionsForEmails = arraySort(array, "email");
    return { optionsForNames, optionsForEmails };
  };
  const { optionsForEmails, optionsForNames } = sort(filters);
  return (
    <>
      <div className="filters__wrapper">
        <div className="user-filters">
          {selectedTypeOption === "User" ? (
            <>
              <div className="select-box-no-width filters__wrapper__email">
                <p>Email</p>
                <MultiSelectDropdown
                  {...defaultParams}
                  labelKey="email"
                  options={optionsForEmails}
                />
              </div>
              <div className="select-box-no-width filters__wrapper__name">
                <p>Name</p>
                <MultiSelectDropdown {...defaultParams} options={optionsForNames} />
              </div>
            </>
          ) : null}
        </div>
        {sourceType === "clubready" ? <FilterByType /> : null}
      </div>
    </>
  );
};

export default Filters;
